import styled from "styled-components";

const PersonalWrapper = styled.div`
    padding-bottom: 2%;
`;

const PersonalInfoStyle = styled.div`
    text-align: center;
`;
const PersonalContactStyle = styled.div`
    text-align: center;
`;

export { PersonalWrapper, PersonalInfoStyle, PersonalContactStyle };
